import {
    IOptionPickerColorItem,
    OPTION_PICKER_TYPE_COLOR,
    OptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { StateProps } from 'Container/App/interface';
import mountOptionPicker from 'Component/OptionPicker';
import {
    changeColor,
    selectCurrentColor,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { selectColorOptions } from 'Container/App/selectors';

/**
 * Mount color picker
 */
const mountColorOptionPicker = (
    containerId: string,
): OptionPicker | null => {
    const dispatch = useDispatch();

    const items: IOptionPickerColorItem[] = [];

    const onChange = (event: Event) => {
        dispatch(
            changeColor(
                decodeURIComponent((event.target as HTMLInputElement).value),
            ),
        );
    };

    const colorOptionPicker = mountOptionPicker(containerId, 'option-picker-color', OPTION_PICKER_TYPE_COLOR, items, onChange);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectColorOptions(currentState) !== selectColorOptions(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const availableColors = selectColorOptions(listenerApi.getState());
            const currentColor = selectCurrentColor(listenerApi.getState());

            colorOptionPicker?.update({
                items: convertColorsFromApiToColorOptionPickerItems({
                    availableColors,
                    currentColor,
                }),
            });
        },
    });

    return colorOptionPicker;
};

/**
 * Convert colors from API to color option picker items
 */
const convertColorsFromApiToColorOptionPickerItems = (
    { currentColor, availableColors }: Pick<StateProps, 'currentColor' | 'availableColors'>,
): IOptionPickerColorItem[] | undefined => {
    const items: IOptionPickerColorItem[] = [];

    for (const color of availableColors!) {
        let optChecked = false;

        if (currentColor === color.displayLabel) {
            optChecked = true;
        }

        items.push({
            // We need to encode the value, because the API operates with HTML entities
            // (e.g. 'Gr&#252;n' instead of 'Grün'). It's decoded in the reducer.
            stdValue: encodeURIComponent(color.displayLabel),
            stdPrimaryLabel: color.displayLabel,
            stdColor: `rgb(${color.primaryColorRgb})`,
            optChecked,
        });
    }

    return items;
};

export default mountColorOptionPicker;
